"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const emotion_1 = require("emotion");
const colors = __importStar(require("../colors"));
const BlockButton_1 = __importDefault(require("../Utilities/BlockButton"));
const ascDirection = 'asc';
const descDirection = 'desc';
const Triangle = ({ up, active, style = {} }) => (react_1.default.createElement("div", { style: Object.assign({ width: '0px', height: '0px', borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderBottom: up ? `5px solid ${active ? colors.alloy : colors.shale}` : 'none', borderTop: up ? 'none' : `5px solid ${active ? colors.alloy : colors.shale}` }, style) }));
Triangle.propTypes = {
    up: prop_types_1.default.bool,
    active: prop_types_1.default.bool,
    style: prop_types_1.default.shape({}),
};
const TableHeader = (_a) => {
    var { children, className, sortable, sorted, toggleSort } = _a, rest = __rest(_a, ["children", "className", "sortable", "sorted", "toggleSort"]);
    const direction = sorted && (sorted.desc ? 'desc' : 'asc');
    const sortIcons = (react_1.default.createElement("div", null,
        react_1.default.createElement(Triangle, { active: direction === ascDirection, up: true }),
        react_1.default.createElement(Triangle, { active: direction === descDirection, style: { marginTop: '2px' } })));
    return (react_1.default.createElement(BlockButton_1.default, Object.assign({ className: emotion_1.cx('rt-th', className), role: "columnheader", tabIndex: "-1" }, rest, { onClick: e => toggleSort && toggleSort(e) }),
        children,
        sortable ? sortIcons : null));
};
TableHeader.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    sortable: prop_types_1.default.bool,
    toggleSort: prop_types_1.default.func,
    sorted: prop_types_1.default.shape({
        desc: prop_types_1.default.any,
    }),
};
exports.default = TableHeader;
